module.exports = __webpack_public_path__ + "img/title01.82d8392a.svg";